var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-center"},[_vm._v("No hay elementos para mostrar")])
}
var staticRenderFns = []

export { render, staticRenderFns }